/**
 * The org id for FullStory shared by cloud and grafana.
 */ export const FULL_STORY_ORG_ID = '18266V';

//# sourceMappingURL=full-story.js.map